import Icon from "hardcover-ui/components/Icon";
import BookListGroup from "components/BookGroup/groups/BookListGroup";
import Divider from "components/ui/Divider";
import { listLink } from "constants/ExploreLinks";
import Heading from "hardcover-ui/components/Heading";
import TextLink from "hardcover-ui/components/TextLink";
import { ListSerializersListGroup, PageSerializersUsersShowPublic } from "types/serializers";

export default function PinnedLists({
  user,
  lists,
}: {
  user: PageSerializersUsersShowPublic;
  lists: ListSerializersListGroup[];
}) {
  if (lists.length === 0) {
    return <></>;
  }

  return (
    <section className="space-y-4">
      <div className="flex flex-row justify-between items-baseline">
        <Heading level={2} size="md">
          <Icon icon={listLink.iconDuo} size="md" className="mr-2" />
          <span>{user.name}'s Pinned Lists</span>
        </Heading>
        <TextLink
          variant="secondary"
          underline={false}
          href={`/@${user.username}/lists`}
          className="hidden lg:block"
        >
          See All lists
        </TextLink>
      </div>

      <div className="mt-8">
        {lists.map((list) => (
          <div key={`book-list-${list.id}`} className="pt-4 space-y-8">
            <BookListGroup key={`book-list-${list.id}`} list={list} size="lg" />
            <Divider />
          </div>
        ))}
      </div>
    </section>
  );
}
